import { Component, OnInit } from '@angular/core';
import { IdentityBase } from '@arianee/arianeejs/dist/src/models';
import { DisplayMapperService, LoaderService } from '@arianeeprivate/wallet-shared-components';
import { ActionSheetController, ModalController, NavController } from '@ionic/angular';
import { ArianeeApiService } from '../../../providers/arianee-api-service/arianee-api.service';
import { AskForBrandDialogComponent } from './components/ask-for-brand-dialog/ask-for-brand-dialog.component';
import { EventLoggerService } from '../../../providers/event-logger/event-logger-service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-arianee-brands-list',
  templateUrl: './arianee-brands-list.page.html',
  styleUrls: ['./arianee-brands-list.page.scss'],
  providers: []

})
export class ArianeeBrandsListPage implements OnInit {
  identitiesSummary: IdentityBase[];
  sortedIdentitiesSummary: IdentityBase[];
  selectedSortIndex = 0;

  constructor (
    private arianeeApiService: ArianeeApiService,
    private displayMapperService: DisplayMapperService,
    private navCtrl: NavController,
    private loaderService: LoaderService,
    private eventLoggerService:EventLoggerService,
    public modalController: ModalController,
    public actionSheetController: ActionSheetController,
    private translateService: TranslateService
  ) {}

  ngOnInit (): void {}

  async ionViewDidEnter () {
    this.eventLoggerService.logScreen('arianee-brand-list');
    this.loaderService.showLoader();
    this.arianeeApiService.getIdentities().subscribe((identities: IdentityBase[]) => {
      this.identitiesSummary = identities;
      this.sortedIdentitiesSummary = identities;
      this.loaderService.dismiss();
    }, () => {
      this.loaderService.dismiss();
    });
  }

  onClickOnBrand (brandId: string): void {
    this.eventLoggerService.logEvent('arianee-brand-list_clickOnBrand', { address: brandId });
    this.navCtrl.navigateForward('/brand-page/' + brandId);
  }

  async presentModal () {
    this.eventLoggerService.logEvent('arianee-brand-list_clickAskForNewBrand');
    const modal = await this.modalController.create({
      component: AskForBrandDialogComponent,
      cssClass: 'auto-height'
    });
    return modal.present();
  }

  /**
   * Open Sort menu
   */
  async openSortDialog () {
    const actionSheet = await this.actionSheetController.create({
      header: this.translateService.instant('ArianeeBrandsList.sort_dialog_title'),
      cssClass: 'brands-list-action-sheet',
      buttons: [{
        text: this.translateService.instant('ArianeeBrandsList.relevance'),
        icon: 'checkmark',
        cssClass: this.selectedSortIndex === 0 ? 'active' : '',
        handler: () => this.defaultSortBrands()
      }, {
        text: 'A-Z',
        icon: 'checkmark',
        cssClass: this.selectedSortIndex === 1 ? 'active' : '',
        handler: () => this.descSortBrands()
      }, {
        text: 'Z-A',
        icon: 'checkmark',
        cssClass: this.selectedSortIndex === 2 ? 'active' : '',
        handler: () => this.ascSortBrands()
      }]
    });
    await actionSheet.present();
  }

  /**
   * Reset Brand List Sort
   */
  defaultSortBrands () {
    this.selectedSortIndex = 0;
    this.sortedIdentitiesSummary = this.identitiesSummary;
    this.eventLoggerService.logEvent(
      'arianee-brand-list_sorted', 'Relevance'
    ).then();
  }

  /**
   * Desc Sort Brand List by Name
   */
  descSortBrands () {
    if (this.selectedSortIndex !== 1) {
      this.selectedSortIndex = 1;
      this.sortedIdentitiesSummary = Object.assign([], this.identitiesSummary).sort((a: IdentityBase, b: IdentityBase) => {
        const aName: string = a.data.name.toLowerCase().trim();
        const bName: string = b.data.name.toLowerCase().trim();
        return aName < bName ? -1 : 1;
      });
      this.eventLoggerService.logEvent(
        'arianee-brand-list_sorted', 'A-Z'
      ).then();
    }
  }

  /**
   * Asc Sort Brand List by Name
   */
  ascSortBrands () {
    if (this.selectedSortIndex !== 2) {
      this.selectedSortIndex = 2;
      this.sortedIdentitiesSummary = Object.assign([], this.identitiesSummary).sort((a: IdentityBase, b: IdentityBase) => {
        const aName: string = a.data.name.toLowerCase().trim();
        const bName: string = b.data.name.toLowerCase().trim();
        return aName > bName ? -1 : 1;
      });
      this.eventLoggerService.logEvent(
        'arianee-brand-list_sorted', 'Z-A'
      ).then();
    }
  }
}
